import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-success-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './info-cuentas-dialog.html',
  styleUrls: ['./info-cuentas-dialog.less']
})
export class InfoCuentasDialog {
icon: any;
title: any;
message: any;
buttonText: any;
isError: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<InfoCuentasDialog>
  ) { }

  closeDialog(): void {
    this.dialogRef.close();
  }
} 